import { useCallback } from "react";
import { StyleSheet } from "react-native";
import Modal from "react-native-modal";

import { Block, Button, Typography, palette, spacing } from "@stepapp/ui";

import { useDialogDispatch, useDialogState } from "../hooks/useDialogModal";

const ANIMATION_DURATION = 500;

const DialogModal = () => {
  const dialogDispatch = useDialogDispatch();
  const { visible, title, description, primaryAction, secondaryAction } = useDialogState();

  const toggle = useCallback(() => {
    dialogDispatch({ type: "closeModal" });
  }, [dialogDispatch]);

  const handlePrimaryAction = useCallback(() => {
    toggle();
    setTimeout(() => {
      primaryAction?.onPress();
    }, ANIMATION_DURATION + 100);
  }, [primaryAction, toggle]);

  const handleSecondaryAction = useCallback(() => {
    toggle();
    setTimeout(() => {
      secondaryAction?.onPress?.();
    }, ANIMATION_DURATION + 100);
  }, [secondaryAction, toggle]);

  return (
    <Modal
      useNativeDriverForBackdrop
      animationOutTiming={ANIMATION_DURATION}
      backdropOpacity={0.5}
      isVisible={visible}
      onBackButtonPress={toggle}
      onBackdropPress={toggle}
      onSwipeComplete={toggle}
      swipeDirection="down"
      useNativeDriver={false}
    >
      <Block margin={1} paddingHorizontal={3} paddingVertical={2} style={styles.container}>
        <Block paddingBottom={2}>
          <Typography center variant="sectionTitle">
            {title}
          </Typography>
        </Block>

        <Block paddingBottom={4}>
          <Typography center type="secondary">
            {description}
          </Typography>
        </Block>

        {primaryAction && (
          <Button label={primaryAction.title} onPress={handlePrimaryAction} type="primary" />
        )}

        {secondaryAction && (
          <Button
            label={secondaryAction.title}
            onPress={handleSecondaryAction}
            textStyle={styles.secondaryButton}
            type="transparent"
          />
        )}
      </Block>
    </Modal>
  );
};

export default DialogModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.common.white,
    borderRadius: spacing.radius * 2,
  },
  secondaryButton: {
    color: palette.font.secondary,
  },
});
